import { AnimatePresence } from 'framer-motion';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';
import { FAQsSection } from './FAQsSection';
import { ContactSection } from './ContactSection';
import { useEffect } from 'react';
import { useAppDispatch } from 'helpers/hooks';
import { getFaqs } from 'store/faqs/actions';

export const ContactScreen = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getFaqs('contact'));
  }, []);

  return (
    <HeaderAndFooterLayout
      footerVisible={true}
      footerShowSupportCta={true}
      headerVisible={true}
      isLoading={false}
      hasIssues={true}
    >
      <AnimatePresence>
        <FAQsSection />
        <ContactSection />
      </AnimatePresence>
    </HeaderAndFooterLayout>
  );
};
